/* Public browser subscription endpoint only. A 202 accepts a request; it does not verify credit or double opt-in. */
(() => {
  'use strict';
  const revision='2026-07-15';
  let retryAt=0;
  const validId=value=>typeof value==='string' && /^[A-Za-z0-9]{6,32}$/.test(value.trim());
  const configured=config=>Boolean(config && validId(config.siteId) && validId(config.listId));
  function failure(message,status=0) {
    const error=new Error(message);error.userMessage=message;error.status=status;return error;
  }
  async function subscribe(config,input) {
    if(!configured(config))throw failure('Email signup is not configured yet. Please try again later.');
    if(input.consent!==true)throw failure('Please choose to receive Rosie’s emails before subscribing.');
    if(retryAt>Date.now())throw failure('Please wait '+Math.ceil((retryAt-Date.now())/1000)+' seconds before trying again.',429);
    const email=String(input.email||'').trim();
    if(!email || email.length>254)throw failure('Please enter a valid email address.');
    const properties={
      'Rosie Signup Source':'welcome-credit-popup',
      'Rosie Campaign':input.campaign,
      'Rosie Shopping Country':input.country,
      'Rosie Checkout Currency':input.currency,
      'Rosie Email Signup Test':Boolean(input.test),
      'Rosie Consent Version':'rosie-email-credit-2026-09',
      'Rosie Consent Collected At':new Date().toISOString()
    };
    if(Number.isFinite(input.offerAmount) && input.offerAmount>0)properties['Rosie Offer Amount Shown']=input.offerAmount;
    if(typeof input.code==='string' && /^[A-Za-z0-9_-]{3,60}$/.test(input.code))properties['Rosie Welcome Code']=input.code;
    const body={data:{type:'subscription',attributes:{
      custom_source:input.test?'Rosie welcome popup — email signup test':'Rosie welcome credit popup',
      profile:{data:{type:'profile',attributes:{email,properties,subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}
    },relationships:{list:{data:{type:'list',id:config.listId.trim()}}}}};
    const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),12000);
    try {
      const response=await fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(config.siteId.trim()),{
        method:'POST',mode:'cors',credentials:'omit',cache:'no-store',signal:controller.signal,
        headers:{Accept:'application/vnd.api+json','Content-Type':'application/vnd.api+json',revision},body:JSON.stringify(body)
      });
      if(response.status===429){
        const value=response.headers.get('Retry-After');
        const seconds=value && /^\d+$/.test(value)?Number(value):(value?(Date.parse(value)-Date.now())/1000:30);
        retryAt=Date.now()+Math.max(1,Math.min(3600,Number.isFinite(seconds)?seconds:30))*1000;
        throw failure('Too many signup attempts. Please wait '+Math.ceil((retryAt-Date.now())/1000)+' seconds and try again.',429);
      }
      if(response.status!==202)throw failure(response.status===400?'We couldn’t save that signup. Check your email address and try again.':'Email signup is unavailable just now. Please try again.',response.status);
      return {accepted:true};
    } catch(error) {
      if(error.userMessage)throw error;
      throw failure(error.name==='AbortError'?'We couldn’t confirm that the signup request arrived. Check your inbox before trying again.':'We couldn’t reach email signup. Please check your connection or content blocker and try again.');
    } finally {clearTimeout(timer);}
  }
  window.RosieKlaviyoSignup=Object.freeze({configured,subscribe});
})();
